import {
    Input,
    Select,
    SimpleGrid,
    Spinner,
    Center,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";
import PercentField from "components/elements/PercentField";
import { formatFieldTypeValue } from "utils/helpers";
import moment from "moment";

const PropertyTypeFields = ({
    fields,
    values,
    setValues,
    columns = 2,
    name,
}: {
    fields: any[];
    values: any;
    setValues: (values: any[]) => void;
    columns?: number;
    name?: string;
}) => {
    const getValueByFieldId = (fieldId: any): string => {
        if (values && values.length > 0) {
            if (name === "property_details") {
                const value = values.find(
                    (field: any) => field.property_field === fieldId
                );
                if (value) {
                    return formatFieldTypeValue(
                        value.property_detail_fields.type,
                        value.value.field
                    );
                }
            } else if (name === "borrower_details") {
                const value = values.find(
                    (field: any) => field.borrower_field === fieldId
                );
                if (value) {
                    return formatFieldTypeValue(
                        value.borrower_fields.type,
                        value.value.field
                    );
                }
            }
        }
        return "";
    };

    const handleValueChange = (fieldId: any, event: any) => {
        const updatedValues = values.map((field: any) => {
            if (name === "property_details") {
                if (field.property_field === fieldId) {
                    field.value.field = event.target.value;
                }
                return field;
            } else if (name === "borrower_details") {
                if (field.borrower_field === fieldId) {
                    field.value.field = event.target.value;
                }
                return field;
            }
        });
        setValues(updatedValues);
    };

    if (fields.length === 0) {
        return (
            <Center>
                <Spinner />
            </Center>
        );
    }

    return (
        <SimpleGrid columns={columns} spacingX="20px">
            {fields
                .sort((a, b) => a.id - b.id)
                .map((field) => (
                    <FormControl
                        isRequired={field.required}
                        key={field.id}
                        w="100%"
                        alignItems="flex-start"
                        mb="22px"
                    >
                        <FormLabel fontSize="14px" fontWeight="500" mb="0px">
                            {field.label}
                        </FormLabel>
                        {(field.type === "text" ||
                            field.type === "encrypted") && (
                            <Input
                                value={getValueByFieldId(field.id)}
                                placeholder={field.placeholder}
                                variant="primary"
                                onChange={(event) =>
                                    handleValueChange(field.id, event)
                                }
                            />
                        )}
                        {field.type === "dropdown" && (
                            <Select flex="1">
                                <option value="">
                                    {" "}
                                    {field.placeholder ||
                                        "Select an option"}{" "}
                                </option>
                                {field.options?.map((o: string) => (
                                    <option key={o} value={o}>
                                        {o}
                                    </option>
                                ))}
                            </Select>
                        )}
                        {field.type === "date" && (
                            <Input
                                value={
                                    getValueByFieldId(field.id)
                                        ? moment(
                                              getValueByFieldId(field.id)
                                          ).format("YYYY-MM-DD")
                                        : ""
                                }
                                onChange={(event) =>
                                    handleValueChange(field.id, event)
                                }
                                placeholder="MM/DD/YYYY"
                                type="date"
                                variant="primary"
                                minHeight="2.5rem"
                            />
                        )}
                        {field.type === "percentage" && (
                            <PercentField
                                value={getValueByFieldId(field.id) || ""}
                                onChange={(event) =>
                                    handleValueChange(field.id, event)
                                }
                            />
                        )}
                        {field.type === "dollar" && (
                            <Input
                                value={getValueByFieldId(field.id)}
                                placeholder={field.placeholder}
                                variant="primary"
                                onChange={(event) =>
                                    handleValueChange(field.id, event)
                                }
                            />
                        )}
                        {field.type === "number" && (
                            <Input
                                value={getValueByFieldId(field.id)}
                                placeholder={field.placeholder}
                                variant="primary"
                                onChange={(event) =>
                                    handleValueChange(field.id, event)
                                }
                            />
                        )}
                    </FormControl>
                ))}
        </SimpleGrid>
    );
};

export default PropertyTypeFields;
